export const THEME_STORAGE_KEY = 'theme'

export type ThemePreference = 'bright' | 'dark' | 'automatic'
export type ResolvedTheme = 'bright' | 'dark'

export const THEME_PREFERENCES: ThemePreference[] = ['bright', 'dark', 'automatic']

export const isThemePreference = (value: string | null): value is ThemePreference =>
    value === 'bright' || value === 'dark' || value === 'automatic'

export const getThemePreference = (): ThemePreference => {
    if (typeof window === 'undefined') return 'automatic'
    const stored = localStorage.getItem(THEME_STORAGE_KEY)
    return isThemePreference(stored) ? stored : 'automatic'
}

export const getSystemPrefersDark = (): boolean => {
    if (typeof window === 'undefined') return false
    return window.matchMedia('(prefers-color-scheme: dark)').matches
}

export const resolveTheme = (preference: ThemePreference, systemPrefersDark = getSystemPrefersDark()): ResolvedTheme => {
    if (preference === 'automatic') {
        return systemPrefersDark ? 'dark' : 'bright'
    }
    return preference
}

export const applyResolvedTheme = (resolved: ResolvedTheme) => {
    const isDark = resolved === 'dark'
    document.documentElement.classList.toggle('dark', isDark)
    document.documentElement.style.colorScheme = isDark ? 'dark' : 'light'
}

export const applyThemePreference = (preference: ThemePreference) => {
    applyResolvedTheme(resolveTheme(preference))
}

export const setThemePreference = (preference: ThemePreference) => {
    localStorage.setItem(THEME_STORAGE_KEY, preference)
    applyThemePreference(preference)
}
